import { Box, IconButton, Image, Text } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import useIsLandScape from "../../../hook/useIsLandScape";
import { isAndroid, isIOS } from "mobile-device-detect";
import usePwaDetected from "../../../hook/usePwaDetected";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";
const HiddenAddressBar = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`common.${key}`, { ...props });

  const isPortrait = window.innerWidth < window.innerHeight; // 判斷是否為直向 (寬度小於高度)
  const fullScreenHight = isPortrait ? window.outerWidth : window.outerHeight; // 根據直向或橫向，取得 window 外部高度 (用於判斷是否有橡皮筋效果)

  const isMobileAndLandScape = useIsLandScape({ isMobile: true }); // 判斷是否為手機且橫向

  const [forceClose, setForceClose] = useState(false); // 強制關閉狀態

  const isPwa = usePwaDetected();

  const [currentWindowInnerHeight, setCurrentWindowInnerHeight] = useState(
    window.innerHeight
  ); // 紀錄當前 window 內部高度
  const [currentWindowFullScreenHeight, setCurrentWindowFullScreenHeight] =
    useState(fullScreenHight); // 紀錄當前 window 外部高度

  const showHiddenAddressBarState = useMemo(() => {
    return forceClose
      ? false
      : currentWindowFullScreenHeight - currentWindowInnerHeight > 30 &&
          isMobileAndLandScape &&
          isIOS &&
          !isPwa;
  }, [
    currentWindowFullScreenHeight,
    currentWindowInnerHeight,
    isMobileAndLandScape,
    isPwa,
    forceClose,
  ]);

  // 監聽 window resize，更新 innerHeight
  useEffect(() => {
    const handleResize = () => {
      setCurrentWindowInnerHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // 監聽螢幕方向變化，更新 fullScreenHeight
  useEffect(() => {
    const handleOrientationChange = () => {
      setCurrentWindowFullScreenHeight(
        isPortrait ? window.outerWidth : window.outerHeight
      );
    };

    window.addEventListener("orientationchange", handleOrientationChange);

    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, [isPortrait]);

  useEffect(() => {
    if (showHiddenAddressBarState) {
      document.body.style.overscrollBehavior = "none";
    }
  }, [showHiddenAddressBarState]);

  return (
    <>
      {/* 判斷是否出現橡皮筋效果：
          當 fullScreenHeight 與 innerHeight 差距超過 30 且
          為手機橫屏、iOS 並且非 PWA 模式時，顯示提示動畫
          此處加上 className="scrollable"，以便在全局 touchmove 事件中排除 */}
      {showHiddenAddressBarState ? (
        <>
          <Box
            position="absolute"
            top="0"
            left="0"
            w="100%"
            h="200%"
            zIndex={99999}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            bg="rgba(0,0,0,0.5)"
          >
            <Box
              position="absolute"
              right="50px"
              top="20px"
              alignSelf={"flex-end"}
              display={"flex"}
              alignItems={"center"}
              onClick={() => {
                setForceClose(true);
              }}
            >
              <IconButton fontSize="40px">
                <IoClose />
              </IconButton>
              <Text>{i18n("關閉滑動提示")}</Text>
            </Box>
            <Image
              w="250px"
              src="https://egslot.net/Images/Iframe/drag_animation.gif"
            />
          </Box>
        </>
      ) : null}{" "}
    </>
  );
};

export default HiddenAddressBar;
